/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * Used to support quote/customer specific details
 */
export var CustomQuoteStatus;
(function (CustomQuoteStatus) {
    CustomQuoteStatus["ACTIVE"] = "Active";
    CustomQuoteStatus["NO_BID"] = "No Bid";
    CustomQuoteStatus["NEEDS_REVIEW"] = "Needs Review";
})(CustomQuoteStatus || (CustomQuoteStatus = {}));
